// 面试官进行管理
export const INTERVIEW_TABLE_DATA = "INTERVIEW_TABLE_DATA";
export const LOAD_TABLE_START = "LOAD_TABLE_START";
export const LOAD_TABLE_DONE = "LOAD_TABLE_DONE";
export const CANCELINTERVIEW_TABLE_DATA = "CANCELINTERVIEW_TABLE_DATA";
export const SEARCH_TABLE_DATA = "SEARCH_TABLE_DATA";

export const SHOW_INTERVIEW_MODAL = "SHOW_INTERVIEW_MODAL";
// 隐藏面试官列表MODAL
export const HIDE_INTERVIEW_MODAL = "HIDE_INTERVIEW_MODAL";
// 面试官成员列表
export const INTERVIEW_LIST_DATA = "INTERVIEW_LIST_DATA";




// WEBPACK FOOTER //
// ./src/constants/interview.js